import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadPmmChecklist'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={
          'PMM PM PdM プロダクトマーケティングマネージャー プロジェクトマネージャー プロダクトマネージャー GAFAM Go-to-Market戦略 SaaS グロース戦略'
        }
        image={'https://www.i3design.jp/ogp_logo.png'}
        url={'https://www.i3design.jp/download/pmmchecklist/'}
        title="プロダクト開発成功のカギ | 資料ダウンロード | i3DESIGN アイスリーデザイン"
        description="GAFAなどの大手外資系IT企業で標準化が進んでいるPMM（プロダクトマーケティングマネージャー）についての詳細な解説や、PdM（プロダクトマネージャー）との分業の仕組み、導入する際のチェックリストを作成しました。"
      />
      <Template />
    </>
  )
}

export default Download
